/**
 * Search in tree view can only match root rows: `useHierarchyTree.fetchRoots`
 * sends `filters: { parent_id: null }` together with the search term, so a
 * leaf two levels down is invisible to it. While a search is active we render
 * the flat list instead, which searches the whole table.
 *
 * The stored preference is untouched — clearing the search restores the tree.
 */
import type { ListViewKind } from '@/shared/listViews'

export function resolveActiveListView(view: ListViewKind, search: string): ListViewKind {
  if (view === 'tree' && search.trim() !== '') return 'list'
  return view
}
